import { useTranslation } from 'react-i18next';
import { Gender } from 'applicaiton/constants/gender';

/**
 * Custom hook that returns an array of objects representing gender options for a form or dropdown.
 * Each object has a `label` and a `value` property. The `label` is the translated text for the
 * gender option, and the `value` is the corresponding Gender enum value.
 *
 * @returns An array of objects with `label` and `value` properties representing gender options.
 */
export const useGenderOptions = () => {
  const { t } = useTranslation();

  return [
    { label: t('personal_information.gender.male'), value: Gender.Male },
    { label: t('personal_information.gender.female'), value: Gender.Female },
  ];
};
